@if (rows.length) {
  <table
    class="navinta-table monitoring-grouped-parts-table"
    [class.has-category]="showCategory"
    [class.no-category]="!showCategory"
  >
    <thead>
      <tr>
        <th
          class="odx-text"
          [class.col-8]="showCategory"
          [class.col-9]="!showCategory"
          i18n="@@monitoring.groupedParts.table.quantity"
        >
          Quantity
        </th>
        <th
          class="odx-text"
          [class.col-23]="showCategory"
          [class.col-26]="!showCategory"
          i18n="@@monitoring.groupedParts.table.name"
        >
          Name
        </th>
        <th
          class="odx-text"
          [class.col-14]="showCategory"
          [class.col-16]="!showCategory"
          i18n="@@monitoring.groupedParts.table.partNumber"
        >
          Part number
        </th>
        @if (showCategory) {
          <th class="odx-text col-14" i18n="@@monitoring.groupedParts.table.category">Category</th>
        }
        <th
          class="odx-text"
          [class.col-21]="showCategory"
          [class.col-25]="!showCategory"
          i18n="@@monitoring.groupedParts.table.description"
        >
          Description
        </th>
        <th
          class="odx-text"
          [class.col-20]="showCategory"
          [class.col-24]="!showCategory"
          i18n="@@monitoring.groupedParts.table.links"
        >
          Links
        </th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track $index) {
        <tr [class.discontinued]="row.isAvailable === false">
          <td [class.col-8]="showCategory" [class.col-9]="!showCategory">{{ row.quantity }}</td>
          <td [class.col-23]="showCategory" [class.col-26]="!showCategory">{{ row.name }}</td>
          <td [class.col-14]="showCategory" [class.col-16]="!showCategory">
            {{ row.partNumber + (row.isAvailable === false ? " " : "") }}
            @if (row.isAvailable === false) {
              <img src="assets/warning-colored-odx.svg" alt="warning" [odxTooltip]="tooltipTextWarningSign" />
            }
          </td>
          @if (showCategory) {
            <td class="col-14">{{ row.category }}</td>
          }
          <td [class.col-21]="showCategory" [class.col-25]="!showCategory">{{ row.description }}</td>
          <td [class.col-20]="showCategory" [class.col-24]="!showCategory">
            <div class="links">
              @if (row.configurationURL) {
                <a odxLink [href]="row.configurationURL" target="_blank" rel="noopener noreferrer">
                  <span i18n="@@global.productDatasheet">Produktdatenblatt</span>
                </a>
              }
              @if (row.piSheetURL) {
                <a odxLink [href]="row.piSheetURL" target="_blank" rel="noopener noreferrer">
                  <span i18n="@@monitoringConfiguration.optionCard.piSheetURL">Produktinformationsblatt</span>
                </a>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
